/*
 * Copyright 2020 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import {
  ListItem,
  ListItemSecondaryAction,
  Tooltip,
  ListItemText,
  makeStyles,
  IconButton,
  Typography,
} from '@material-ui/core';
import EmailIcon from '@material-ui/icons/Email';
import { DatadogOnCallEntry } from './types';

const useStyles = makeStyles({
  listItemPrimary: {
    fontWeight: 'bold',
    fontSize: '0.8rem',
  },
});

type Props = {
  entry: DatadogOnCallEntry;
};

export const DatadogOnCallUser = ({ entry }: Props) => {
  const classes = useStyles();

  // Extract schedule label (e.g., "primary" from "ccoe-sre-team-primary")
  const scheduleParts = entry.schedule.attributes.name.split('-');
  const scheduleLabel = scheduleParts[scheduleParts.length - 1];

  return (
    <ListItem>
      <ListItemText
        primary={
          <Typography className={classes.listItemPrimary}>
            {entry.user.attributes.name}
          </Typography>
        }
        secondary={scheduleLabel}
      />
      <ListItemSecondaryAction>
        <Tooltip title="Send e-mail to user" placement="top">
          <IconButton href={`mailto:${entry.user.attributes.email}`}>
            <EmailIcon color="primary" />
          </IconButton>
        </Tooltip>
      </ListItemSecondaryAction>
    </ListItem>
  );
};
